exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lyrics-component{height:300px;padding-left:14px;text-align:center}.lyrics-component audio{display:none}.lyrics-component pre{margin:auto;font-family:OratorStd;font-size:9pt;line-height:16px;height:475px;overflow-y:scroll;word-wrap:break-word;white-space:pre-line}.lyrics-component a{font-size:9pt;font-family:OratorStd;line-height:20px;padding-top:10px;text-decoration:underline}.lyrics-component a:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/Lyrics.css
// module id = 722
// module chunks = 0